// extracted by mini-css-extract-plugin
module.exports = {"title":"title--3Dhru","list":"list--2XLmB","returnItem":"returnItem--2FxBx"};